import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { API_ROOT, roleType } from "../../constants";
import { LOGOUT_USER_CLEAR } from "../../actions/chat";
import { getUserDetails } from "../../actions/getUserDetail";
import InstructorHeaderContent from "./InstructorHeaderContent";
import ChatNotificationList from "../header/ChatNotificationList";
import NotificationList from "../header/NotificationList";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

class TopBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: "",
      userImage: null,
      userId: "",
      userRole: null,
      buildingId: null,
    };
  }

  componentDidMount() {
    let user = JSON.parse(localStorage.getItem("auth"));
    if (user && user.UserProfile && user.UserProfile.name) {
      this.setState({
        userName: user.UserProfile.name,
        userRole: user?.Roles?.[0]?.name,
      });
      this.state.userName = user.UserProfile.name;
    }
    // if (user && user.UserProfile && user.UserProfile.Attachment && user.UserProfile.Attachment.path) {
    //     this.setState({ userImage: `${API_ROOT}/${user.UserProfile.Attachment.path}` });
    //     this.state.userImage = `${API_ROOT}/${user.UserProfile.Attachment.path}`;
    // }
    if (user && user.UserProfile && user.UserProfile.user_id) {
      this.setState({ userId: user.UserProfile.user_id });
      this.state.userId = user.UserProfile.user_id;
      this.getUserDetails(this.state.userId);
    }
  }

  getUserDetails(user_id) {
    return getUserDetails({ userId: user_id })
      .then((result) => {
        let userDetails = result.data.responseData;

        if (
          result.data.responseData &&
          result.data.responseData.UserProfile &&
          result.data.responseData.UserProfile.Attachment &&
          result.data.responseData.UserProfile.Attachment.path
        ) {
          this.setState({
            userImage: `${API_ROOT}/${result.data.responseData.UserProfile.Attachment.path}`,
            userRole: result.data.responseData?.Roles?.[0]?.name,
            buildingId: userDetails?.Company?.Building?.id ?? null,
          });
          // this.setState({ userDetails: result.data.responseData });
        }
      })
      .catch((error) => {});
  }

  render() {
    const { userImage, userRole, userName, userId, buildingId } = this.state;
    return (
      <div>
        <header
          id="header-panel-home"
          className={`${
            userRole === roleType?.instructor ? "instructor-header-custom" : ""
          }`}
        >
          <div className="row align-items-center">
            <div className="col-sm-6 col-10">
              {userRole ? (
                userRole === roleType?.instructor ? (
                  <InstructorHeaderContent
                    userName={userName}
                    userId={userId}
                  />
                ) : (
                  <NavLink to={`/landing`}>
                    <img
                      className="img-fluid"
                      src="/assets/images/admin-logo.svg"
                      alt="img"
                    />
                  </NavLink>
                )
              ) : null}
            </div>
            <div className="col-sm-6 col-2">
              <div className="header-right">
                <ul className="bell">
                  {userRole && userRole === roleType?.instructor ? (
                    <>
                      <ChatNotificationList buildingId={buildingId} />
                    </>
                  ) : (
                    <li>
                      <span className="bell-icon">
                        <span className="badge">14</span>
                      </span>
                    </li>
                  )}
                  <li>
                    <div className="dropdown profile">
                      <button
                        type="button"
                        className="dropdown-toggle"
                        data-toggle="dropdown"
                      >
                        <span className="profile-pic">
                          <img
                            className="img-fluid"
                            src={
                              userImage
                                ? userImage
                                : "/assets/images/no-user.jpeg"
                            }
                          />
                        </span>
                        <span className="name">{this.state.userName}</span>
                      </button>
                      <div className="dropdown-menu">
                        <ul className="removedPaddingLeft">
                          <li className="dropdown-item">
                            <NavLink to="/profile" activeClassName="active">
                              Profile
                            </NavLink>
                          </li>
                          <li
                            className="dropdown-item"
                            onClick={this.props.logOut}
                          >
                            <NavLink to="/" activeClassName="active">
                              Log Out
                            </NavLink>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </header>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    logOut: () => {
      dispatch(LOGOUT_USER_CLEAR());
    },
  };
};
export default connect(null, mapDispatchToProps)(TopBar);
